import React, { Fragment } from 'react';

import API from '../../../../utils/API';


import InputField from '../../../../components/inputs/inputField';
import FieldModal from '../../../../components/modals/fieldModal';
import { withRouter } from 'react-router-dom';

class DuplicateFromModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: this.props.name ? this.props.name : '',
            submitting: false,
            requiredFields: { name: false }
        };
    }

    handleNameChange = (e) => {
        this.setState({
            name: e.target.value
        });
    };

    duplicateForm = async () => {
        this.setState({ submitting: true });
        const { name } = this.state;
        const { eventId, orgId, email, update, toggle, formId } = this.props;
        const requiredFields = this.state.requiredFields;
        let valid = true;
        if (!name) {
            requiredFields.name = true;
            valid = false;
        }
        if (valid) {
            await API()
                .post(`Organizations/${orgId}/events/${eventId}/form/`, {
                    name: name,
                    duplicateId: formId

                })
                .then((res) => {

                    if (res.data) {

                        window.open(`/${orgId}/events/${eventId}/forms/${res.data._id}`, '_self');

                    }
                });
        } else {
            this.setState({ submitting: false, requiredFields: requiredFields });
        }
    };

    render() {
        const { isOpen, toggle } = this.props;
        const { submitting, name, requiredFields } = this.state;

        return (
            <div>

                <FieldModal
                    size="medium"
                    isOpen={isOpen}
                    modalTitle={"Duplicate Form"}
                    bodyHeaderText={'Please enter name for your duplicated email.'}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    label="Name"
                                    value={name}
                                    required={true}
                                    errorTrigger={requiredFields.name}
                                    onChange={this.handleNameChange}
                                />
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Duplicate' : 'Duplicating...'}
                    actionButton={() => this.duplicateForm()}
                    actionButtonDisabled={submitting}


                ></FieldModal>
            </div>

        );
    }
}

export default withRouter(DuplicateFromModal);
